import { render, staticRenderFns } from "./GetStart.vue?vue&type=template&id=542f08be&scoped=true"
import script from "./GetStart.vue?vue&type=script&lang=js"
export * from "./GetStart.vue?vue&type=script&lang=js"
import style0 from "./GetStart.vue?vue&type=style&index=0&id=542f08be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f08be",
  null
  
)

export default component.exports